module.exports = __webpack_public_path__ + "static/media/pullman02.1821b597.jpg";